module.exports = {"data":{"site":{"siteMetadata":{"title":"Gatsby Typescript Starter"}}},"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/index.json
// module id = 292
// module chunks = 142629428675168